
import makerjs from "makerjs";
function C04(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    R = Param[0].param,R1 = Param[1].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r = R * 1 * myZoom, 
       r1 = R1 * 1 * myZoom,     
       h = 2*r,
       w = 2*r,
      rd=r1/Math.sqrt(2),
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
     
       x=r,y=r,glassH = h, glassW = w;

       if (r !== 0) {
        var TxtR = "R="+R;
    }if (r1 !== 0) {
      var TxtR1 = "R1="+R1;
  } 


   var drawAbnormalShapeC04 = {
       paths: {
        "holesOUp": new makerjs.paths.Arc([r, r], r, 180,0),
        "holesODn": new makerjs.paths.Arc([r, r], r, 0,180),
        "holesAUp": new makerjs.paths.Arc([r, r], r1, 180,0),
        "holesADn": new makerjs.paths.Arc([r, r], r1, 0,180),
    
       }
   };
   var drawAbnormalShapeC04MarkD = {
       paths: {
        "LeftLine": new makerjs.paths.Line([0, r], [r, r]),
       }
   };
   var drawAbnormalShapeC04MarkR1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([r, r], [r+rd, r+rd]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeC04MarkD, TxtR, [r, r+markShift], [r+3*markShift, r+markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC04MarkR1, TxtR1, [r+rd+markShift, r+rd+markShift], [r+rd+3*markShift, r+rd+markShift]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeC04: drawAbnormalShapeC04,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC04: drawAbnormalShapeC04,
        drawAbnormalShapeC04MarkD: drawAbnormalShapeC04MarkD,
        drawAbnormalShapeC04MarkR1: drawAbnormalShapeC04MarkR1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C04;